import styles from "./ThinkingMessage.module.css";

export function ThinkingMessage() {
	return (
		<div className={styles.container}>
			<div className={styles.bubble}>
				<div className={styles.icon} />
				<span className={styles.text}>Thinking</span>
				<span className={styles.dots}>
					<span className={styles.dot}>.</span>
					<span className={styles.dot}>.</span>
					<span className={styles.dot}>.</span>
				</span>
			</div>
		</div>
	);
}
